import React from 'react'
import { IGenerarPdfColumna } from '../../modules/Forms/SharedComponents/containers/GenerarPdf/interfaces'
import { PdfDownloadLinkReporteLaridae } from '../../modules/Movimiento/shared/pdfDownloadLinkReporteLaridae/containers/pdfDownloadLinkReporteLaridae'

export const pdfCustomToolbarGenerator = ( 
  title: string,
  data: {[key: string]: string|number}[],
  columns:IGenerarPdfColumna[], 
  orientation:'portrait'|'landscape' = 'portrait',
  descripcion = ' ') => () => (
    <PdfDownloadLinkReporteLaridae 
      filas={data} 
      columnas={columns} 
      orientacion={orientation} 
      titulo={title} 
      descripcion={descripcion} 
    />
)